/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Thanks_Meta_DescriptionInputs */

const ja_playdata_thanks_meta_description = /** @type {(inputs: Playdata_Thanks_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせいただきありがとうございます。`)
};

const en_playdata_thanks_meta_description = /** @type {(inputs: Playdata_Thanks_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for contacting PLAYDATA.`)
};

/**
* | output |
* | --- |
* | "Thank you for contacting PLAYDATA." |
*
* @param {Playdata_Thanks_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_thanks_meta_description = /** @type {((inputs?: Playdata_Thanks_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Thanks_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_thanks_meta_description(inputs)
	return en_playdata_thanks_meta_description(inputs)
});